module.exports = __webpack_public_path__ + "static/img/forever_vip_bg.c0a60384.png";